<ng-container *ngIf="(currentStep$ | async)?.componentName === componentName">
  <ng-content></ng-content>
</ng-container>
